import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getMakeoverComments = createAsyncThunk(
  "ListingDetail/getMakeoverComments",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/transactions/makeover/${data.id}/comment?pageNumber=1&pageSize=1000`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(
          error.response.data.errorMessage || error.response.data.message
        );
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
